import { NgModule } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { LayoutsComponent } from './layouts/layouts.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DetailsPanelComponent } from './details-panel/details-panel.component';
import { AssignedDetailsPanelComponent } from './assigned-details-panel/assigned-details-panel.component';
import { LeadHistoryComponent } from './lead-history/lead-history.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NotificationComponent } from './notification/notification.component';
import { MatTimepickerModule, provideNativeDateTimeAdapter } from "@dhutaryan/ngx-mat-timepicker";
import { NewLeadAlertComponent } from './new-lead-alert/new-lead-alert.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';
import { SplitLinesPipe } from './split-lines.pipe';


@NgModule({
  declarations: [
    LayoutsComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    DetailsPanelComponent,
    AssignedDetailsPanelComponent,
    LeadHistoryComponent,
    NotificationComponent,
    NewLeadAlertComponent,
    SplitLinesPipe
  ],

  imports: [
    RouterModule,
    NgbDropdownModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    NgxSkeletonLoaderModule,
    MatTimepickerModule,
    DragDropModule,
    MatIconModule
  ],
  exports: [HeaderComponent, LayoutsComponent, FooterComponent, SidebarComponent, RouterModule, DetailsPanelComponent, AssignedDetailsPanelComponent, LeadHistoryComponent, NotificationComponent, NewLeadAlertComponent],
  providers: [provideNativeDateTimeAdapter()],
})
export class SharedModule { }
